import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const categoryService = {
    getAllCategories, 
    updateCategoryStatus,
    getCategory,
    updateCategory,
    createCategory,
  };

const MODULE = {
    CATEGORY: 'rnd-categories',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Category') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllCategories(filter) {
   
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        name: filter.name,
        is_active: filter.isActive
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
    
    return apiHelper(API_URL).get(`/${MODULE.CATEGORY}`, requestOptions)
}


export function updateCategoryStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.CATEGORY}/${data.id}`, requestOptions)
}

export async function getCategory(id) {
  return await apiHelper(API_URL).get(`/${MODULE.CATEGORY}/${id}`)
}

export function updateCategory(data) {
  const requestOptions = {
    name: data.name,
    is_active: data.isActive,
  }

  return apiHelper(API_URL).put(`/${MODULE.CATEGORY}/${data.id}`, requestOptions)
}

export function createCategory(data) {
  const requestOptions = {
    name: data.name,
  }
  return apiHelper(API_URL).post(`/${MODULE.CATEGORY}`, requestOptions)
}